import {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {InfoSection} from '../../../app/components/InfoSection';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {useGetBiobookFavoritesQuery} from '../../../app/services/biobookApi';
import {selectSession} from '../../auth/authSlice';
import {useAssistantUtils} from '../../core/hooks/useAssistantUtils';
import {useDemo} from '../../demo/hooks/useDemo';
import {BiobookPage} from '../components/BiobookPage';
import {BiobookPageSkeleton} from '../components/BiobookPageSkeleton';
import {useGetBiotwinQuery} from '../../../app/services/biotwinApi';
import {useReadOnly} from '../../biotwin/hooks/useReadOnly';
import {getErrorMessage} from '../../../app/utils/miscUtils';
export const Bookmarks = () => {
  const params = useParams<{
    userId: string;
  }>();
  const session = useAppSelector(selectSession);
  const userId = Number(params.userId ?? session?.id ?? 0);
  const {
    data: biotwin,
    error: errorGetBiotwin,
    isFetching: isFetchingGetBiotwin,
  } = useGetBiotwinQuery({
    id: userId,
  });
  const {isReadOnly} = useReadOnly();
  const readOnly = isReadOnly(biotwin);
  const {
    data: favorites,
    error,
    isFetching,
  } = useGetBiobookFavoritesQuery(
    {
      userId,
    },
    {
      skip: !biotwin || readOnly,
    },
  );
  const {isDemo} = useDemo();
  const {pushAssistantContent} = useAssistantUtils();
  useEffect(() => {
    if (isDemo) {
      return pushAssistantContent({
        detail: 'You can see the biobook pages you have saved here.',
        detailDelay: 1000,
        summary: 'Here are your bookmarks.',
      });
    }
  }, [isDemo]);
  return (
    <div className="flex-1 flex flex-col gap-6 min-h-full p-6 overflow-auto">
      {isFetchingGetBiotwin && <BiobookPageSkeleton />}
      {!isFetchingGetBiotwin && errorGetBiotwin && (
        <InfoSection
          className="flex-1"
          icon="exclamation-circle"
          message={getErrorMessage(errorGetBiotwin)}
          title="Error"
        />
      )}
      {!isFetchingGetBiotwin && readOnly && (
        <InfoSection className="flex-1" icon="info-circle" message="You have no bookmarked pages." title="No Pages" />
      )}
      {isFetching && <BiobookPageSkeleton />}
      {!isFetching && error && (
        <InfoSection className="flex-1" icon="exclamation-circle" message={getErrorMessage(error)} title="Error" />
      )}
      {!isFetching && !error && favorites != null && favorites.length === 0 && (
        <InfoSection className="flex-1" icon="info-circle" message="You have no bookmarked pages." title="No Pages" />
      )}
      {!isFetching &&
        !error &&
        favorites != null &&
        favorites.length > 0 &&
        favorites.map((favorite) => (
          <BiobookPage biobookPage={favorite} key={favorite.phraseId} showBodyLifeMapLabels userId={userId} />
        ))}
    </div>
  );
};
